export type CacheSetting = {
    endpoint: CacheEndpoint
    isCacheUpToDate: boolean
    lastNotificationDateTime: Date
}

export type CacheSettings = {
    values: CacheSetting[]
}

export type UpdateCacheSettingDto = {
    Endpoint: CacheEndpoint
    IsCacheUpToDate: boolean
}

export type UserCacheControl = {
    sessionID: string
    userId: number
    companyId: number
    parentCompanyId?: number
    cacheSettingsString: string | null
    createdDateTime: Date
    lastUpdateDateTime?: Date
    get cacheSettings(): CacheSettings | null
    set cacheSettings(value: CacheSettings | null)
}

export enum CacheEndpoint {
    WorkOrderUpcomingThreshold = "WorkOrderUpcomingThreshold",
    CompanyCompanyAlias = "CompanyCompanyAlias",
    CompanyDistrictUnitsInUse = "CompanyDistrictUnitsInUse",
    CompanyDistrictSubDistrictsInUse = "CompanyDistrictSubDistrictsInUse",
    CompanyGroupGroupsInUse = "CompanyGroupGroupsInUse",
    CompanyDistrictDistrictsInUse = "CompanyDistrictDistrictsInUse",
    WorkOrderCBACode = "WorkOrderCBACode",
    WorkOrderServiceCode = "WorkOrderServiceCode",
    WorkOrderUrgency = "WorkOrderUrgency",
    CompanyAssetModelAssetModelsInUse = "CompanyAssetModelAssetModelsInUse",
    CompanyAssetTypeAssetTypesInUse = "CompanyAssetTypeAssetTypesInUse",
    CompanyAssetCategoryAssetCategoriesInUse = "CompanyAssetCategoryAssetCategoriesInUse",
    CompanyAssetClassAssetClassesInUse = "CompanyAssetClassAssetClassesInUse",
    CompanyAssetMakeAssetMakesInUse = "CompanyAssetMakeAssetMakesInUse",
    CompanyCompanySubCompaniesInUse = "CompanyCompanySubCompaniesInUse",
    CompanySiteSiteInUse = "CompanySiteSiteInUse",
    CompanySite = "CompanySite",
    WorkOrderServiceSubType = "WorkOrderServiceSubType",
    WorkOrderServiceCodeGetServiceCodesInUseIsAssignToWorkOrderTrue = "WorkOrderServiceCodeGetServiceCodesInUseIsAssignToWorkOrderTrue",
    WorkOrderServiceCodeGetServiceCodesInUseIsAssignToWorkOrderFalse = "WorkOrderServiceCodeGetServiceCodesInUseIsAssignToWorkOrderFalse",
    MaintenanceMechanicGetMechanics = "MaintenanceMechanicGetMechanics",
    CompanyPerson = "CompanyPerson",
    AssetTimeZone = "AssetTimeZone",
    ServiceScheduleGetServiceItems = "ServiceScheduleGetServiceItems",
}

export function mapCacheEndpointFromEndpointPath(endpointPath: string): CacheEndpoint | null {
    switch (endpointPath) {
        case "/core-api/UpcomingThreshold":
            return CacheEndpoint.WorkOrderUpcomingThreshold
        case "/core-api/CompanyAlias":
            return CacheEndpoint.CompanyCompanyAlias
        case "/core-api/District/UnitsInUse":
            return CacheEndpoint.CompanyDistrictUnitsInUse
        case "/core-api/District/SubDistrictsInUse":
            return CacheEndpoint.CompanyDistrictSubDistrictsInUse
        case "/core-api/Group/GroupsInUse":
            return CacheEndpoint.CompanyGroupGroupsInUse
        case "/core-api/District/DistrictsInUse":
            return CacheEndpoint.CompanyDistrictDistrictsInUse
        case "/core-api/CBACode":
            return CacheEndpoint.WorkOrderCBACode
        case "/core-api/ServiceCode":
            return CacheEndpoint.WorkOrderServiceCode
        case "/core-api/Urgency":
            return CacheEndpoint.WorkOrderUrgency
        case "/core-api/AssetModel/AssetModelsInUse":
            return CacheEndpoint.CompanyAssetModelAssetModelsInUse
        case "/core-api/AssetType/AssetTypesInUse":
            return CacheEndpoint.CompanyAssetTypeAssetTypesInUse
        case "/core-api/AssetCategory/AssetCategoriesInUse":
            return CacheEndpoint.CompanyAssetCategoryAssetCategoriesInUse
        case "/core-api/AssetClass/AssetClassesInUse":
            return CacheEndpoint.CompanyAssetClassAssetClassesInUse
        case "/core-api/AssetMake/AssetMakesInUse":
            return CacheEndpoint.CompanyAssetMakeAssetMakesInUse
        case "/core-api/Company/SubCompaniesInUse":
            return CacheEndpoint.CompanyCompanySubCompaniesInUse
        case "/core-api/Site/SiteInUse":
            return CacheEndpoint.CompanySiteSiteInUse
        case "/core-api/Site":
            return CacheEndpoint.CompanySite
        case "/core-api/ServiceSubType":
            return CacheEndpoint.WorkOrderServiceSubType
        case "/core-api/ServiceCode/GetServiceCodesInUse?IsAssignToWorkOrder=true":
            return CacheEndpoint.WorkOrderServiceCodeGetServiceCodesInUseIsAssignToWorkOrderTrue
        case "/core-api/ServiceCode/GetServiceCodesInUse?IsAssignToWorkOrder=false":
            return CacheEndpoint.WorkOrderServiceCodeGetServiceCodesInUseIsAssignToWorkOrderFalse
        case "/core-api/Mechanic/GetMechanics":
            return CacheEndpoint.MaintenanceMechanicGetMechanics
        case "/core-api/Person":
            return CacheEndpoint.CompanyPerson
        case "/core-api/TimeZone":
            return CacheEndpoint.AssetTimeZone
        case "/core-api/ServiceSchedule/GetServiceItems":
            return CacheEndpoint.ServiceScheduleGetServiceItems
        default:
            return null
    }
}

export function mapToUpdateCacheSettingDto(setting: CacheSetting): UpdateCacheSettingDto {
    return {
        Endpoint: setting.endpoint,
        IsCacheUpToDate: setting.isCacheUpToDate,
    }
}
